const baseUrl = process.env.NODE_ENV === 'production' ? '/api/template' : 'https://staging-tracking-v2.merchize.com/api/template'

export const getTemplate = () => {
    return `${baseUrl}/template-tracking.csv`
}



